/**
 * @param {number} column
 * @param {string} sortDirection
 * @param {boolean} reset
 * @param {boolean} alreadySorted
 * @returns {string}
 */

let preSortOrder = [];
export const sortTable = (column, sortDirection, reset = false, alreadySorted = false) => {
	const tableBody = document.querySelector('#hits tbody');
	if (!tableBody) return;

	// reset to the results from before sort
	if (reset) {
		tableBody.innerHTML = "";
		[...preSortOrder].map(row => {
			row.querySelectorAll('td')[column].classList.remove('active');
			tableBody.appendChild(row);
		})
		return;
	}

	// need to query each time in case there are more or less rows than before
	const tableRows = tableBody.querySelectorAll('tr');
	if (!tableRows) return;

	// remove all active column classes
	const activeColumns = Array.from(tableBody.querySelectorAll('.active'));
	activeColumns.forEach(col => {
		col.classList.remove('active');
	})

	// keep a reference to previous sort state
	// only update the saved state if a sort is NOT already active
	if (!alreadySorted) {
		preSortOrder = tableRows;
	}

	// clear it out
	tableBody.innerHTML = "";
	const sortedRows = [...tableRows].sort((a, b) => {
		let firstRow = a.querySelectorAll('td')[column].dataset.value;
		let secondRow = b.querySelectorAll('td')[column].dataset.value;

		// if there's any missing data
		if (sortDirection === 'desc') {
			if (!firstRow || firstRow === 'undefined') {
				return 1;
			}
			if (!secondRow || secondRow === 'undefined') {
				return -1;
			}
		}
		if (sortDirection === 'asc') {
			if (!firstRow || firstRow === 'undefined') {
				return -1;
			}
			if (!secondRow || secondRow === 'undefined') {
				return 1;
			}
		}

		// if we are looking at numbers
		if (!isNaN(parseFloat(firstRow))) {
			if (sortDirection === 'desc') {
				return parseFloat(secondRow) - parseFloat(firstRow);
			}
			return parseFloat(firstRow) - parseFloat(secondRow);
		}

		// looking at text
		if (sortDirection === 'desc') {
			return firstRow < secondRow ? 1 : -1;
		}
		return firstRow < secondRow ? -1 : 1;
	});

	// add active class and append the new rows
	sortedRows.map(sortedRow => {
		sortedRow.querySelectorAll('td')[column].classList.add('active');
		tableBody.appendChild(sortedRow);
	})

}
